import { Button } from '#/components/Button/Button';
import { Status } from '#/components/Status/Status';
import { AppStatus, ButtonVariant } from '#/service/constants';
import { tb } from '#/store/translation/translation.store';

import { ButtonContainer, Message } from './PlanPurchaseFlow.styled';
import { NextSubscriptionDetails } from './PlanPurchaseFlow.types';

interface Props {
  onClose: () => void;
  nextSubscriptionDetails: NextSubscriptionDetails;
}

export const ChangeProductSuccess = ({
  onClose,
  nextSubscriptionDetails,
}: Props) => {
  const changeDateMessage = nextSubscriptionDetails.isImmediateSwitch
    ? tb('iap.success.upgrade.immediateSwitch')
    : tb('iap.success.upgrade.nextPlanChangeDate', {
        date: nextSubscriptionDetails.changeDate?.toLocaleDateString(
          undefined,
          {
            month: 'long',
            day: 'numeric',
            year: 'numeric',
          }
        ),
      });

  return (
    <Status
      applyDefaultGradient={false}
      status={AppStatus.Success}
      statusTitle={tb('iap.success.upgrade.title')}
    >
      <Message>{tb('iap.success.upgrade.successMessage')}</Message>
      <Message>{changeDateMessage}</Message>
      <ButtonContainer>
        <Button onClick={onClose} variant={ButtonVariant.Primary}>
          {tb('button.ok')}
        </Button>
      </ButtonContainer>
    </Status>
  );
};
